import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportError } from './reporter';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  failed: boolean;
}

/**
 * Catches a throw during render. Without one, React 18+ unmounts the whole tree
 * and the user is left with a blank screen.
 *
 * Not the only emitter: a rejected promise never passes through render, so it
 * reaches installReporter's unhandledrejection hook instead.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    reportError(error, { componentStack: info.componentStack ?? undefined });
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    if (this.props.fallback !== undefined) return this.props.fallback;
    return (
      <div role="alert">
        <p>Algo salió mal al mostrar esta sección.</p>
        <button type="button" onClick={() => window.location.reload()}>
          Recargar
        </button>
      </div>
    );
  }
}
